import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/icon/action/delete.svg'


const _hoisted_1 = { class: "wrap-section" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "txt-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "del"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "container-content-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Sidebar, {
      class: "hjp-sidebar",
      visible: _ctx.show,
      showCloseIcon: false,
      dismissable: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.titleModal), 1),
            (_ctx.dataForm && _ctx.canDelete)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "wrap-ic-del",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
                }, _hoisted_5))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "form")
          ])
        ])
      ]),
      _: 3
    }, 8, ["visible"]),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.attrModalConfirmation.show,
      imgContent: _ctx.attrModalConfirmation.imgContent,
      title: _ctx.attrModalConfirmation.title,
      subTitle: _ctx.attrModalConfirmation.subTitle,
      btnSubmitTitle: _ctx.attrModalConfirmation.btnSubmitTitle,
      btnBackTitle: _ctx.attrModalConfirmation.btnBackTitle,
      onHideDialog: _ctx.hideDialogConfirmation,
      onOnSubmit: _ctx.onSubmitConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "btnBackTitle", "onHideDialog", "onOnSubmit"])
  ]))
}